import PdfGenerator from './PdfGenerator';

class RubricaElencoOrganizzazioni extends PdfGenerator {

    constructor(){
        super();
        this.i = 0;
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    doDrawRow(row, data){
        let doc = data.doc;
        if (this.i % 2 === 0){
            doc.setFillColor(240);
            doc.rect(data.settings.margin.left, row.y, data.table.width, row.height , 'F');
        }
        if (data.row.raw.note !== ''){
            if (this.i % 2 === 1){
                doc.setFillColor(240);
                doc.rect(data.settings.margin.left, row.y, data.table.width, 10 , 'F');
            }
            else{
                doc.setFillColor(255);
                doc.rect(data.settings.margin.left, row.y, data.table.width, 10 , 'F');
            }
            doc.setFontStyle('italic');
            //doc.text(data.row.raw.note, data.settings.margin.left, row.y + row.height / 2);
            doc.autoTableText(data.row.raw.note, data.settings.margin.left + 20 , row.y + 2, {
                halign: 'left',
                valign: 'middle'
            });
            data.cursor.y += 10;
            return false;
        } else{
            this.i = this.i + 1;
        }
    }

    createPdf(items){

        const columns = [
            {title: "ID", dataKey: "id"},
            {title: "Nome", dataKey: "nome"},
            {title: "Indirizzo", dataKey: "indirizzo"},
            {title: "PIva/CF", dataKey: "pivacf"},
            {title: "Email/Pec", dataKey: "email"},
            {title: "Telefoni", dataKey: "telefoni"},
            {title: "Cellulare", dataKey: "cellulare"},
            {title: "Fax", dataKey: "fax"},
        ];
        let rows = [];
        items.map((item) => {
            let indirizzo =
                ((item.indirizzo ?  item.indirizzo : '' )+ ' ' +
                (item.cap ? item.cap : '') + ' ' +
                (item.citta ? item.citta : '') + ' ' +
                (item.provincia ? item.provincia : '') + ' ' +
                (item.stato ? item.stato : '')).trim() ;
            let pivacf =
                ((item.piva ? 'p.iva:' + item.piva : '') +
                (item.cfisc ? 'c.f.:' + item.cfisc : '')).trim();
            let email =
                ((item.email ? item.email : '') +
                (item.pec ? ' ' + item.pec : '')).trim();
            let telefoni =
                ((item.telefono1 ?  item.telefono1 : '') +
                (item.telefono2 ? ' ' + item.telefono2 : '')).trim();
            let note =
                ((item.web ?  'Sito web: ' + item.web : '') +
                    (item.note ? ' Note: ' + item.note : '')).trim();

            let it = {
                id: item.idOrganizzazione,
                nome: item.nome,
                indirizzo: indirizzo,
                pivacf:  pivacf,
                email: email,
                telefoni: telefoni,
                cellulare: item.cellulare,
                fax: item.fax,
                note: '',
            };
            rows.push(it);
            if (note){
                rows.push(Object.assign({}, it, {note: note}));
            }
            return 0;
        });

        super.createPdf(columns, rows,
            {
                drawRow: this.doDrawRow,
                theme: 'plain',
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 8,
                },
                columnStyles: {
                    nome: {halign: 'left', columnWidth: 'auto'},
                    indirizzo: {halign: 'left', columnWidth: 'auto'},
                    pivacf: {halign: 'left', columnWidth: '200'},
                    email: {halign: 'left', columnWidth: 'wrap'},
                    note: {halign: 'left', columnWidth: 'auto'},
                }
            });
    }


}

export default RubricaElencoOrganizzazioni;


/** WEBPACK FOOTER **
 ** ./src/pdf/RubricaElencoOrganizzazioni.js
 **/